import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/Vertical_logo.svg'
import _imports_1 from '@/assets/icons/plus-border-icon.svg'
import _imports_2 from '@/assets/icons/incomplete-icon.svg'


const _withScopeId = n => (_pushScopeId("data-v-7af76515"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header-wrapper" }
const _hoisted_2 = { class: "title-search-wrapper d-flex align-items-center justify-content-between" }
const _hoisted_3 = { class: "title-block d-flex flex-row w-100" }
const _hoisted_4 = {
  key: 0,
  class: "logo"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "logo"
}, null, -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { class: "title-nav d-flex flex-column w-100" }
const _hoisted_8 = { class: "nav cursor-pointer subtitle" }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ps-2 pe-2" }, "-", -1))
const _hoisted_11 = { class: "title d-flex align-items-center justify-content-between" }
const _hoisted_12 = { class: "process-name" }
const _hoisted_13 = { class: "d-flex align-items-center" }
const _hoisted_14 = { class: "me-2" }
const _hoisted_15 = {
  "data-bs-toggle": "modal",
  "data-bs-target": "#ClientUsersModal",
  class: "cursor-pointer"
}
const _hoisted_16 = {
  key: 1,
  class: "add-milestone cursor-pointer d-flex align-items-center",
  "data-bs-toggle": "modal",
  "data-bs-target": "#addStepModal"
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "me-2",
  src: _imports_1,
  alt: "plus-border-icon"
}, null, -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Add milestone", -1))
const _hoisted_19 = [
  _hoisted_17,
  _hoisted_18
]
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "me-2",
  src: _imports_2,
  alt: "incomplete-icon"
}, null, -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Incomplete task only", -1))
const _hoisted_22 = [
  _hoisted_20,
  _hoisted_21
]
const _hoisted_23 = {
  key: 3,
  class: "btn btn-outline-primary me-3 float-end add-button",
  "data-bs-toggle": "modal",
  "data-bs-target": "#addNewModal"
}
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ps-3 ms-1 inline-block" }, "Add", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AvatarsRow = _resolveComponent("AvatarsRow")!
  const _component_feather_icon = _resolveComponent("feather-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        false
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_6))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            (_ctx.isTemplateBuilder)
              ? (_openBlock(), _createElementBlock("span", {
                  key: 0,
                  class: "cursor-pointer",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push({ name: 'settings-processes' })))
                }, " Process template"))
              : _createCommentVNode("", true),
            (!_ctx.isTemplateBuilder)
              ? (_openBlock(), _createElementBlock("span", _hoisted_9, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.clientName), 1),
                  _hoisted_10,
                  _createElementVNode("span", null, _toDisplayString(_ctx.project.name), 1)
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", null, [
              _createElementVNode("h2", _hoisted_12, _toDisplayString(_ctx.process.name), 1)
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _createVNode(_component_AvatarsRow, {
                    users: _ctx.externalUsers,
                    middleAvatarSize: true
                  }, null, 8, ["users"])
                ])
              ]),
              false
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: _normalizeClass(["toggle-list cursor-pointer", { 'task-list': _ctx.showTaskList }]),
                    onClick: _cache[1] || (_cache[1] = ($event: any) => {_ctx.showTaskList = !_ctx.showTaskList; _ctx.$emit('setShowTaskList', _ctx.showTaskList)})
                  }, [
                    _createElementVNode("span", {
                      class: _normalizeClass(_ctx.showTaskList ? 'left' : 'left-selected')
                    }, "Task List", 2),
                    _createElementVNode("span", {
                      class: _normalizeClass(_ctx.showTaskList ? 'right' : 'right-selected')
                    }, "Module Board", 2)
                  ], 2))
                : _createCommentVNode("", true),
              (_ctx.isTemplateBuilder && !_ctx.showTaskList)
                ? (_openBlock(), _createElementBlock("div", _hoisted_16, _hoisted_19))
                : _createCommentVNode("", true),
              false
                ? (_openBlock(), _createElementBlock("div", {
                    key: 2,
                    class: _normalizeClass(["incomplete-task cursor-pointer d-flex align-items-center", { 'active': _ctx.showOnlyCompletedModule }]),
                    onClick: _cache[2] || (_cache[2] = ($event: any) => {_ctx.showOnlyCompletedModule = !_ctx.showOnlyCompletedModule; _ctx.$emit('setShowOnlyCompletedModule', _ctx.showOnlyCompletedModule);})
                  }, _hoisted_22, 2))
                : _createCommentVNode("", true),
              (!_ctx.isTemplateBuilder)
                ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                    _createVNode(_component_feather_icon, {
                      type: "plus",
                      class: "cursor-pointer add-icon",
                      size: "20"
                    }),
                    _hoisted_24
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ])
    ])
  ]))
}